export function roundToFirstDecimal(num: number) {
  return Math.round(num * 10) / 10;
}
